<template>
	<div 
    :id="dateFormatted"
    ref="dateItem" 
    class="pt-2 calendar-be-custom-date" 
    v-b-tooltip.click
    :title="full_data.min_nights ? `Minimum ${full_data.min_nights} nights required` : ''">
    <p class="font-semibold text-16 lh-1"
    	:class="is_match && (loading_data || full_data.availability == 0) ? 'mb-0' : 'mb-1'">{{formatDateNumber(ori_data)}}</p>
    <template v-if="is_match">
    	<div v-if="loading_data">
    		<pulse-loader size="4px" color="#dcdcdc"></pulse-loader>
    	</div>
	    <template v-else>
	    	<p v-if="full_data.availability == 0" class="mb-0 font-regular text-22 lh-1 text-danger">x</p>
	    	<template v-else>
			    <template v-if="displayMode === 'SHOW_LOWEST_PRICE' && full_data.lower_price > 0">
			      <p class="font-regular text-10 mb-0 lh-1 w-100">{{formatCurrencyCompact($formatCurrencyCustom('price',full_data.lower_price))}}</p>
			    </template>
			    <template v-if="displayMode === 'SHOW_AVAILABILITY'">
			      <p class="font-regular text-10 mb-0 lh-1 w-100">{{full_data.availability}}</p>
			    </template>
			    <div v-if="full_data.not_closed_to_departure == 0" class="calendar-be-custom-date-ctd"></div>
			    <div v-if="full_data.not_closed_to_arrival == 0" class="calendar-be-custom-date-cta"></div>
		    </template>
	    </template>
    </template>
  </div>
</template>
<script type="text/javascript">
	import moment from 'moment'
	import { mapGetters } from 'vuex'
	export default{
		props:['ori_data','api_data'],
		computed:{
			...mapGetters(['getCurrentLanguage','getMerchant']),
			displayMode(){
				return (this.getMerchant && this.getMerchant.search_room_filter_dates_mode) || 'SHOW_LOWEST_PRICE'
			},
			is_match(){
				return this.api_data.length > 0 ? true : false
			},
			loading_data(){
				if(this.is_match){
					let month_active_index = this.api_data.findIndex(date=>{
	      		let loop_date = moment(date.month).format("M-YYYY")
	      		let selected_date = moment(this.ori_data).format("M-YYYY")
	      		if(loop_date == selected_date){
	      			return true
	      		}else{
	      			return false
	      		}
	      	})
	      	if(month_active_index != -1){
		      	return this.api_data[month_active_index].loading
		      }else{
		        return false
		      }
				}else{
					return false
				}
			},
	    full_data(){
	    	if(this.is_match){
		    	let month = moment(this.ori_data).format("MM")
		      let month_active_index = this.api_data.findIndex(date=>{
	      		let loop_date = moment(date.month).format("M-YYYY")
	      		let selected_date = moment(this.ori_data).format("M-YYYY")
	      		if(loop_date == selected_date){
	      			return true
	      		}else{
	      			return false
	      		}
	      	})
		      if(month_active_index != -1){
		      	let dmy = moment(this.ori_data).format("YYYY-MM-DD")
		        let date_index = this.api_data[month_active_index].dates.findIndex(y=>y.date == dmy)
		        if(date_index != -1){
		          return this.api_data[month_active_index].dates[date_index];
		        }else{
		          return {}
		        }
		      }else{
		        return {}
		      }
		    }else{
					return {}
				}
	    },
      dateFormatted(){
        return this.ori_data ? `date-${moment(this.ori_data).format("YYYY-MM-DD")}` : "";
      }
		},
		methods:{
			formatDateNumber(value){
	      return moment(value).format("D")
	    },
	    formatCurrencyCompact(value){
	      let formatter = Intl.NumberFormat(this.getCurrentLanguage, { notation: 'compact' })
	      return formatter.format(value)
	    },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/CalendarRoomItem.vue